import React, { useEffect, useRef, useState } from "react";
import { TriggerTypeDropdownProps } from "../types";
import { scrollToShowDropdown } from "../../../../utils/dropdownScrollUtils";
import {
  TriggerTypeDropdownContainer,
  TriggerTypeDropdownContent,
  TriggerTypeDropdownIcon,
  TriggerTypeDropdownLabel,
  TriggerTypeDropdownOption,
  TriggerTypeDropdownOptions,
  TriggerTypeDropdownPlaceholder,
  TriggerTypeDropdownValue,
  TriggerTypeDropdownValueText,
} from "../styles";
import { ReactComponent as DropdownDownIconSvg } from "../assets/dropdown-iterative-down.svg";
import { ReactComponent as DropdownUpIconSvg } from "../assets/dropdown-iterative-up.svg";

export const TriggerTypeDropdown: React.FC<TriggerTypeDropdownProps> = ({
  triggerTypes,
  selectedTriggerType,
  onTriggerTypeSelect,
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
      if (!isOpen) {
        // Check if dropdown options are visible and scroll if needed
        setTimeout(() => {
          scrollToShowDropdown(dropdownRef);
        }, 100);
      }
    }
  };

  const handleTriggerTypeSelect = (triggerType: any) => {
    if (!disabled) {
      onTriggerTypeSelect(triggerType);
      setIsOpen(false);
    }
  };

  return (
    <TriggerTypeDropdownContainer
      ref={dropdownRef}
      onClick={handleToggle}
      style={disabled ? { opacity: 0.5, backgroundColor: "#f5f5f5" } : {}}
    >
      <TriggerTypeDropdownContent>
        {disabled ? (
          <TriggerTypeDropdownValue>
            <TriggerTypeDropdownValueText>
              {selectedTriggerType ? selectedTriggerType.value : "Action Type"}
            </TriggerTypeDropdownValueText>
          </TriggerTypeDropdownValue>
        ) : (
          <>
            <TriggerTypeDropdownPlaceholder>
              <TriggerTypeDropdownLabel>Trigger Type</TriggerTypeDropdownLabel>
            </TriggerTypeDropdownPlaceholder>
            <TriggerTypeDropdownValue>
              <TriggerTypeDropdownValueText>
                {selectedTriggerType
                  ? selectedTriggerType.value
                  : "Action Type"}
              </TriggerTypeDropdownValueText>
            </TriggerTypeDropdownValue>
          </>
        )}
      </TriggerTypeDropdownContent>
      {!disabled && (
        <TriggerTypeDropdownIcon>
          {isOpen ? <DropdownUpIconSvg /> : <DropdownDownIconSvg />}
        </TriggerTypeDropdownIcon>
      )}

      {isOpen && !disabled && (
        <TriggerTypeDropdownOptions data-dropdown-options>
          {triggerTypes.map((triggerType: any) => (
            <TriggerTypeDropdownOption
              key={triggerType.key}
              onClick={() => handleTriggerTypeSelect(triggerType)}
            >
              {triggerType.value}
            </TriggerTypeDropdownOption>
          ))}
        </TriggerTypeDropdownOptions>
      )}
    </TriggerTypeDropdownContainer>
  );
};
